/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				d="M3.00024 21.0002H21.0002M3.00024 15.0002H21.0002M12.0002 3.00018L21.0002 3.00018"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.0002 9.00018L21.0002 9.00018M4.00024 3.00018L7.00024 6.00018L4.00024 9.00018"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3.00024 21.0002H21.0002M12.0002 3.00018L21.0002 3.00018M12.0002 9.00018L21.0002 9.00018M4.00024 3.00018L7.00024 6.00018L4.00024 9.00018M3.00024 15.0002H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21H21M12 3L21 3M12 9L21 9M4 3L7 6L4 9M3 15H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M6.00025 21H3.00025M21.0003 21H10.0003M12.0002 3.00018L21.0002 3.00018M12.0002 9.00018L21.0002 9.00018M4.00024 3.00018L7.00024 6.00018L4.00024 9.00018M18.0002 15.0002H21.0002M3.00024 15.0002H14.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.00024 21.0002H21.0002M12.0002 3.00018L21.0002 3.00018M12.0002 9.00018L21.0002 9.00018M4.00024 3.00018L7.00024 6.00018L4.00024 9.00018M3.00024 15.0002H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21H21M12 3L21 3M12 9L21 9M4 3L7 6L4 9M3 15H21"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
